angular.module("contractDocs.components", []).component("contractDocs", {
	templateUrl: "ng/components/contractDocs/contractDocs.view.html",
	bindings: {
	  model: "<",
	  checkDownloadPreventivo: "&?"
	},
	controllerAs: "contractDocsCtrl",
	controller: function () {
	  var self = this;    
  
	  self.$onInit = function () {
		
	  
  
	 
		
   
	  }
  
	  
	 
	
	}
  });